import React from 'react';
import { Box, List, ListItem, ListItemIcon, ListItemText, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useNavigate, useLocation } from 'react-router-dom';
import DashboardIcon from '@mui/icons-material/Dashboard';
import RouterIcon from '@mui/icons-material/Router';
import SignalWifiOffIcon from '@mui/icons-material/SignalWifiOff';
import PowerOffIcon from '@mui/icons-material/PowerOff';
import SensorsIcon from '@mui/icons-material/Sensors';
import SensorsOffIcon from '@mui/icons-material/SensorsOff';
import ErrorIcon from '@mui/icons-material/Error';
import AddCircleIcon from '@mui/icons-material/AddCircle';

const Sidebar = ({ open }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const links = [
    { label: 'Overview', icon: <DashboardIcon />, path: '/' },
    { label: 'Gateways', icon: <RouterIcon />, path: '/gateways' },
    { label: 'Lost Gateways', icon: <SignalWifiOffIcon />, path: '/lost-gateways' },
    { label: 'Water Meters', icon: <SensorsIcon />, path: '/water-meters' },
    { label: 'Lost Water Meters', icon: <SensorsOffIcon />, path: '/lost-water-meters' },
    { label: 'Down Water Meters', icon: <PowerOffIcon />, path: '/down-water-meters' },
    { label: 'Criticals', icon: <ErrorIcon />, path: '/criticals' },
    { label: 'Water Meter Registration', icon: <AddCircleIcon />, path: '/water-meter-registration' },
    { label: 'Gateway Registration', icon: <AddCircleIcon />, path: '/gateway-registration' },
  ];

  return (
    <Box
      sx={{
        width: open ? 240 : 60,
        backgroundColor: '#2c3e50',
        color: 'white',
        overflowY: 'auto',
      }}
    >
      <List>
        {links.map((item, index) => (
          <ListItem button key={index} selected={location.pathname === item.path} onClick={() => navigate(item.path)}>
            <ListItemIcon sx={{ color: 'white', minWidth: isMobile ? 'auto' : undefined }}>
              {item.icon}
            </ListItemIcon>
            {open && <ListItemText primary={item.label} />}
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default Sidebar;
